export default __webpack_public_path__ + "static/media/undead-token.da7d0920.png";